import React from 'react';

const resultCardContext = {
  listingResultTracking: {
    clickedSingle: () => {},
    clickedLogo: () => {},
    clickedTitle: () => {},
    clickedLearnMore: () => {},
    clickedProgramLink: () => {},
    clickedSeeAllPrograms: () => {},
    viewedAllPrograms: () => {},
    viewedHighlights: () => {},
    viewedResult: () => {},
  },
  index: 0,
  schoolName: '',
  isOffsiteConversion: false,
};

const ResultCardContext = React.createContext(resultCardContext);

export default ResultCardContext;
